import { render, staticRenderFns } from "./InputMoneyOld.vue?vue&type=template&id=5940dc7e&"
import script from "./InputMoneyOld.vue?vue&type=script&lang=js&"
export * from "./InputMoneyOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/InputMoneyOld.vue
// module id = 79
// module chunks = 28